<template>
    <div class="purchase-amount-noti">
        <p>※구매하신 상품권은 취소교환이 어려우니 신중히 확인하고 구매해주세요</p>
        <v-dialog v-model="shows" width="400">
            <template #activator="{attrs, on}">
                <v-btn text color="primary" class="pa-0" v-bind="attrs" v-on="on"> 교환환불정책 </v-btn>
            </template>
            <v-card>
                <v-card-title> 교환 환불 정책 </v-card-title>
                <v-card-text class="purchase-amount-noti__info">
                    <p>교환 환불을 원하시는 고객님께서는 help@daehanbooks.co.kr로 아래의 정보를 전달해주세요.</p>

                    <ol class="purchase-amount-noti__list">
                        <li>
                            주민등록증 또는 운전면허증 <br />
                            <small> (뒷자리 가린 이미지) </small>
                        </li>
                        <li>
                            통장 사본 이미지
                        </li>
                        <li>
                            아이디
                        </li>
                        <li>
                            결제금액 및 권종
                        </li>
                    </ol>

                    <p>※ 환불시 소비자 보호법에 의거하여10% 수수료를 제외하고 환불 됩니다.</p>
                    <p>※ 환불은 영업일 기준 2~3일 내에 보내주신 통장으로 수수료를 제외하고 입금됩니다.</p>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="shows = false"> 닫기 </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    setup: () => ({}),
    data: () => ({
        shows: false,
    }),
    computed: {},
    methods: {},
    watch: {},
    mounted() {},
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.purchase-amount-noti {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;

    &__info {
        & > p:not(:last-of-type) {
            margin: 0 0 8px;
        }

        & > ol {
            margin: 24px 0;
        }
    }

    &__list {
        list-style: decimal;
        padding: 0 24px;

        & > li:not(:last-of-type) {
            margin: 0 0 8px;
        }
    }
}
</style>
